import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import api, { API_BASE_URL } from '../api';

export default function StudentLogDetail() {
    const [logData, setLogData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { studentId } = useParams();

    useEffect(() => {
        const fetchLog = async () => {
            try {
                const { data } = await api.get(`/teacher/student-log/${studentId}/`);
                setLogData(data);
            } catch (err) {
                setError('학생 기록을 불러오는 데 실패했습니다.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchLog();
    }, [studentId]);

    if (loading) return <Layout><p>로딩 중...</p></Layout>;
    if (error) return <Layout><p className="message error">{error}</p></Layout>;
    if (!logData) return null;

    return (
        <Layout>
            <Link to="/teacher/overall-status" className="back-link">전체 현황으로</Link>
            <h1>{logData.student_name} 학생 독서 기록</h1>
            <div className="log-container">
                {logData.records.length === 0 ? (
                    <p style={{ textAlign: 'center', gridColumn: '1 / -1' }}>아직 읽은 책이 없습니다.</p>
                ) : (
                    logData.records.map((record) => (
                        <div className="log-item" key={record.id}>
                            {record.book.image ? (
                                <img src={`${API_BASE_URL}${record.book.image}`} alt={record.book.name} />
                            ) : (
                                <div className="no-image-placeholder"><span>이미지 없음</span></div>
                            )}
                            <h3>{record.book.name}</h3>
                            <p>{record.report}</p>
                        </div>
                    ))
                )}
            </div>
        </Layout>
    );
}
